'use strict';

const slickSlider = require('./slick-slider');
const isSmallView = require('./modules/helpers/isSmallView');

function cardValidation() {
    // Exit early if we do not have anything to work with
    if ($('.js-card-message-textarea').length === 0) {
        return false;
    }

    const cardButton = $('.js-write-a-card .js-add-to-cart, .js-giftcard-submit');
    const cardTextarea = $('.js-card-message-textarea');
    const emptyCardCheckbox = $('#empty-card');
    const characterCounter = $('.js-characters-left');
    const maxCharacters = cardTextarea.attr('maxlength');

    characterCounter.html(maxCharacters - cardTextarea.val().length);

    const pgCustomizeEvents = {
        onChange: $.Event('pgCustomize.onChange')
    };

    cardButton.prop('disabled', !cardTextarea.val() && !emptyCardCheckbox.is(':checked'));

    cardTextarea.off('input paste').on('input paste', function() {
        const message = $(this).val();
        characterCounter.html(maxCharacters - message.length);
    });

    cardTextarea.off('keyup').on('keyup', function() {
        $(document).trigger(pgCustomizeEvents.onChange);

        if (!cardTextarea.val()) {
            cardButton.prop('disabled', true);
            return;
        }

        if ($(cardButton).prop('disabled')) {
            $(cardButton).prop('disabled', false);
        }
    });

    cardTextarea.off('focus click').on('focus click' , function() {
        if (!emptyCardCheckbox.is(':checked')) {
            return;
        }
        emptyCardCheckbox.prop('checked', false);
        cardButton.prop('disabled', true);
    });

    emptyCardCheckbox.off('change').on('change', function() {
        if (!$(this).is(':checked')) {
            cardTextarea.val(window.cartText || '');
            cardButton.prop('disabled', !window.cartText);
            const message = cardTextarea.val();
            characterCounter.html(maxCharacters - message.length);
            return true;
        }
        window.cartText = cardTextarea.val();

        if (cardTextarea.val()) {
            $(cardTextarea).val('');
            characterCounter.html(maxCharacters);
        }
        cardButton.prop('disabled', false);
    });

    $(document).on('keypress paste', '.js-card-message-textarea', function() {
        limitWriteACardTextLines(this, $(this).val());
    });
}

//Limit the text in the write a card text area
function limitWriteACardTextLines(textAreaElement, oldText) {
    //Wait until the character is actually inserted
    setTimeout(function () {
        let lineHeight = 25;

        if (isSmallView()) {
            lineHeight = 23;
        }

        if (textAreaElement.scrollHeight - textAreaElement.clientHeight > lineHeight) {
            $(textAreaElement).val(oldText);
        }
    }, 1);
}

const writeACard = {
    init: function(){
        slickSlider.writeACardSlider();
        cardValidation();
    }
};

module.exports = writeACard;
